import { createContext } from 'react';

const ReloadContext = createContext<{ reload: () => void }>({ reload: () => {} });

export default ReloadContext;
